import { Fragment, ReactElement, useMemo } from 'react';
import { DeathNotificationsResidentCrumbs } from 'notifications-from-civil-status/constants/breadcrumb';
import { IdAmbito } from 'shell/constants/id-ambito';
import { DeathNotificationsResidentSubscriptionCrumbs } from 'subscription/constants/breadcrumb';
import { DeathNotificationsResidentMutationCrumbs } from 'mutation/constants/research-notifications-civil-status.crumbs';
import { DeathNotificationsResidentCancellationsCrumbs } from 'cancellations/constants/breadcrumb';
import { getBaseUrl } from 'notifications-from-civil-status/utils/get-base-url';
import { useParams } from 'react-router-dom';
import { DeathNotificationsResidentCivilStatusCrumbs } from 'civil-status/constants/breadcrumb';
import ResearchDeathNotificationResidentShared from '../../research-notifications/research-death';

interface ResearchDeathNotificationResidentCivilStatusSharedProps {
  scope?: string;
}

const ResearchDeathNotificationResidentCivilStatusShared = ({
  scope,
}: ResearchDeathNotificationResidentCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/morte/residenti/cancellazione`;
  }, [goBackUrl]);

  const items = useMemo(() => {
    if (idCat) {
      return DeathNotificationsResidentCivilStatusCrumbs(goBackUrl, idCat);
    }

    if (!scope) {
      return DeathNotificationsResidentCrumbs(goBackUrl);
    }

    switch (scope) {
      case IdAmbito.Iscrizioni:
        return DeathNotificationsResidentSubscriptionCrumbs(goBackUrl);
      case IdAmbito.Mutazioni:
        return DeathNotificationsResidentMutationCrumbs(goBackUrl);
      case IdAmbito.Cancellazioni:
        return DeathNotificationsResidentCancellationsCrumbs(goBackUrl);
      default:
        return [];
    }
  }, [scope, idCat]);

  return (
    <Fragment>
      <ResearchDeathNotificationResidentShared
        goBackUrl={goBackUrl}
        redirectUrl={redirectUrl}
        items={items}
      />
    </Fragment>
  );
};

ResearchDeathNotificationResidentCivilStatusShared.displayName =
  'Research Marriage Notifications Resident Page component';

export default ResearchDeathNotificationResidentCivilStatusShared;
